import React from "react";
import "./AboutPascal.css";
import pascal from "../../img/pascal.png";
import CTASecondary from "../CTASecondary";


function AboutPascal() {
  
  return (
    <div className="AboutPascal">
      <div className="AboutPascal__imagePascal__mobile">
        <img src={pascal} alt="Luxury villa with sea view in Costa Blanca, Spain" />
      </div>
      <div className="AboutPascal__left">
        <h1>About Pascal Bretel</h1>
        <p>
          Introducing Pascal Bretel, an accomplished real estate expert with
          over three decades of invaluable experience spanning Europe and the
          United States. Born in France and holding US citizenship, Pascal
          currently divides his time between Houston, Texas, and Costa Blanca in
          Spain.
        </p>

        <p>
          Specializing in assisting American clients seeking property in Spain,
          Pascal brings a unique international perspective to his work. His
          extensive knowledge of both cultures provides invaluable guidance
          throughout the entire purchasing process, recognizing significant
          differences between procedural intricacies in Spain and the United
          States. From initial consultations to finalizing deals, Pascal is
          committed to making his clients' dreams of owning property abroad a
          reality.
        </p>

        <p>
          With a passion for forging strong client relationships, Pascal treats
          every individual he works with as family. Known for his dedication to
          his clients' needs, he takes the time to truly listen and understand
          their desires, ensuring every detail is meticulously addressed and
          providing tailored service.
        </p>

        <p>
          In Pascal, clients find not only a skilled professional but also a
          trusted confidant dedicated to their success and satisfaction. With
          his attentive nature and unwavering dedication to excellence, Pascal
          Bretel epitomizes a real estate advisor who consistently exceeds
          expectations for his clients.
        </p>
        <br />
        <br />
        <a href="/contact">
         
            <div className="AboutPascal__mobileMargintop">
              <CTASecondary label="Contact us" />
            </div>
     
        </a>
      </div>
      <div className="AboutPascal__right">
        <img src={pascal} alt="Luxury villa with sea view in Costa Blanca, Spain" />
      </div>
    </div>
  );
}

export default AboutPascal;
